import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GlobalStyles, Layout, Content, SubHeader } from "./styles";
import Menu from "./components/Menu";
import Title from "../components/Title";
import Breadcrumb from "../components/Breadcrumb";
import { useLayout } from "../../../provider/LayoutProvider";
import { Flex } from "../../StyledComponents";
import TopBar from "./components/TopBar";

interface ComponentProps { }

const Component = ({ }: ComponentProps) => {
  const { layout } = useLayout();

  return (
    <>
      <GlobalStyles />
      <Layout
        className={layout.sidebarOpened ? "sidebar-opened" : "sidebar-closed"}
      >
        {(layout.showSearchBar || layout.showFilters) && <TopBar />}

        {layout.showSubHeader && (
          <SubHeader>
            <Flex justify="flex-start" column>
              {layout.showTitle && <Title />}
              {layout.showBreadcrumb && <Breadcrumb />}
            </Flex>
          </SubHeader>
        )}

        <Content>
          <Outlet />
        </Content>

        <Menu />

        <ToastContainer />
      </Layout>
    </>
  );
};

export default Component;
